module.exports = __webpack_public_path__ + "img/智能诊断.399a549b.svg";